/**
 * Date utility functions for consistent formatting across the application
 */

import { format, isValid, parseISO } from "date-fns";

/**
 * Format options for date formatting
 */
interface FormatDateOptions {
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow";
  day?: "numeric" | "2-digit";
  year?: "numeric" | "2-digit";
  weekday?: "long" | "short" | "narrow";
}

/**
 * Format a date string using date-fns
 * 
 * @param dateString - ISO date string to format
 * @param options - Formatting options
 * @returns Formatted date string or empty string if invalid
 */
function formatDate(dateString: string, options?: FormatDateOptions): string {
  if (!dateString) return "";
  
  try {
    const date = parseISO(dateString);
    
    if (!isValid(date)) return "";
    
    // Handle different format combinations
    if (options?.month === "long" && options?.day === "numeric" && options?.year === "numeric") {
      return format(date, "MMMM d, yyyy"); // e.g. "January 7, 2025"
    }
    
    if (options?.month && options?.day) {
      return format(date, "MMM dd, yyyy"); // e.g. "Jan 07, 2025"
    }
    
    // Default format
    return format(date, "MMM dd, yyyy");
  } catch (e) {
    return "";
  }
}

// Export utilities
const dateUtils = {
  formatDate
};

export default dateUtils;
export { formatDate }; 